import { EFieldTone } from "../../../../../constants/enum/field-tone";
import i18n, { Ti18nKeys } from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import {
  RISK_CELL_HEIGHT,
  RISK_CELL_PADDING_X,
  RISK_CELL_PADDING_Y,
  RISK_LABEL_FONT_SIZE,
  RISK_LABEL_LETTER_SPACING,
  RISK_STRIPE_WIDTH
} from "./risk-strip-constants";

const RiskCell = withLiteObserverAndTheme<{
  labelKey: Ti18nKeys;
  value: string;
  tone: EFieldTone;
  valueFontSize: number;
}>((props) => {
  const { labelKey, value, tone, valueFontSize, theme } = props;
  const { colors, unitX, unitY } = theme;

  const toneColor = () => {
    switch (tone) {
      case EFieldTone.CRITICAL:
        return colors.all.red;
      case EFieldTone.WARNING:
        return colors.all.darkOrange;
      case EFieldTone.POSITIVE:
        return colors.all.green;
      default:
        return colors.all.maastrichtBlue;
    }
  };
  const isFlagged = tone === EFieldTone.CRITICAL || tone === EFieldTone.WARNING;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={RISK_CELL_HEIGHT}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="center"
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        padding: `${RISK_CELL_PADDING_Y * unitY}px ${
          RISK_CELL_PADDING_X * unitX
        }px`,
        boxShadow: isFlagged
          ? `inset ${RISK_STRIPE_WIDTH * unitX}px 0 0 ${toneColor()}`
          : "none"
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={RISK_LABEL_FONT_SIZE}
        text={i18n.get(labelKey)}
        isSpan={true}
        color={colors.all.davysGrey}
        style={{
          margin: 0,
          textTransform: "uppercase",
          letterSpacing: RISK_LABEL_LETTER_SPACING
        }}
      />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={valueFontSize}
        text={value}
        isSpan={true}
        color={toneColor()}
        style={{ margin: 0 }}
      />
    </ET3Div>
  );
});
export default RiskCell;
